import React from 'react';
import PropTypes from 'prop-types';

import NoReviewsIcon from './NoReviewsIcon';
import {
	Wrapper, Text,
} from './noReviewsStyles';

const NoReviews = ({ anchorName }) => {
	return (
		<Wrapper href={anchorName}>
			<NoReviewsIcon />
			<Text>Be the first to write a review!</Text>
		</Wrapper>
	); 
};

NoReviews.propTypes = {
	anchorName: PropTypes.string,
};

NoReviews.defaultProps = {
	anchorName: "#reviews",
};

export default NoReviews;